// extracted by mini-css-extract-plugin
export default {"tooltip__icon":"Tooltip_tooltip__icon__GKSgc","tooltip__wrap":"Tooltip_tooltip__wrap__oGyc8","tooltip__text":"Tooltip_tooltip__text__4GhSR"};